export default __webpack_public_path__ + "static/media/Maharaja08.50428e85.jpg";